import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import SpaceMonkeyLogo from '../../components/brand/SpaceMonkeyLogo';
import './SpaceMonkeySettingsPage.css';

const SpaceMonkeySettingsPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!localStorage.getItem('authToken')) {
      navigate('/admin/signin');
    }
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('accountType');
    navigate('/admin/signin');
  };

  return (
    <div className="sms-page">
      <header className="sms-header">
        <div className="sms-header-inner">
          <SpaceMonkeyLogo light size="md" />
          <div className="sms-header-right">
            <Link to="/spacemonkey/dashboard" className="sms-header-link">Dashboard</Link>
            <button className="sms-logout-btn" onClick={handleLogout}>Log out</button>
          </div>
        </div>
      </header>

      <div className="sms-content">
        <div className="sms-title-row">
          <div>
            <h1>Account Settings</h1>
            <p>Space Monkey Parking · Edinburg, TX</p>
          </div>
          <Link to="/spacemonkey/dashboard" className="btn btn-secondary">Back to Dashboard</Link>
        </div>

        {/* Account Info */}
        <div className="sms-card">
          <h2>Business Account</h2>
          <div className="sms-field-row">
            <span className="sms-field-label">Business name</span>
            <span className="sms-field-value">Space Monkey Arcade</span>
          </div>
          <div className="sms-field-row">
            <span className="sms-field-label">Location</span>
            <span className="sms-field-value">Edinburg, TX</span>
          </div>
          <div className="sms-field-row">
            <span className="sms-field-label">Account type</span>
            <span className="sms-field-value">Parking Lot Owner</span>
          </div>
          <div className="sms-field-row">
            <span className="sms-field-label">Username</span>
            <span className="sms-field-value">spacemonkey.admin</span>
          </div>
          <p className="sms-note">To update your business info, contact <a href="mailto:support@rgvsmartpay.com">support@rgvsmartpay.com</a>.</p>
        </div>

        {/* Parking Lot Settings */}
        <div className="sms-card">
          <h2>Parking Lot</h2>
          <div className="sms-field-row">
            <span className="sms-field-label">Permit price</span>
            <span className="sms-field-value">$5.00 <span className="sms-field-note">(you receive this)</span></span>
          </div>
          <div className="sms-field-row">
            <span className="sms-field-label">Convenience fee</span>
            <span className="sms-field-value">$1.00 <span className="sms-field-note">(charged to customer, goes to RGV Smart Pay)</span></span>
          </div>
          <div className="sms-field-row">
            <span className="sms-field-label">Customer total</span>
            <span className="sms-field-value">$6.00</span>
          </div>
          <div className="sms-field-row">
            <span className="sms-field-label">Validation codes</span>
            <span className="sms-field-value">SM-12345 · SM-99999 · SM-00001</span>
          </div>
          <p className="sms-note">To change pricing or add validation codes, contact <a href="mailto:support@rgvsmartpay.com">support@rgvsmartpay.com</a>.</p>
        </div>

        {/* Security */}
        <div className="sms-card">
          <h2>Security</h2>
          <div className="sms-field-row">
            <span className="sms-field-label">Password</span>
            <span className="sms-field-value">••••••••</span>
          </div>
          <p className="sms-note">To reset your password, contact <a href="mailto:support@rgvsmartpay.com">support@rgvsmartpay.com</a>.</p>
          <button className="sms-logout-full-btn" onClick={handleLogout}>Log out of this device</button>
        </div>
      </div>
    </div>
  );
};

export default SpaceMonkeySettingsPage;
